/* ==========================================================================
   EMIR PERSO — personnalisation produit + chaîne compagnon (fiche produit)
   Emir ICE — thème Turbo. Remplace Infinite Options.

   Contexte mesuré le 2026-09-11 :
   - Bouton d'ajout « .ajax-submit » (type=button) dans <form action="/cart/add">.
   - Vanga smartcart écoute le clic sur DOCUMENT en capture et ajoute lui-même
     le produit : tout ce qui est posé sur le bouton arrive trop tard, et un
     produit « bundle » n'est jamais ajouté (c'était le bug d'Infinite Options).
   - Bouton de paiement dynamique présent : il saute toute validation.

   Parades :
   1. VERROU : bouton « disabled » tant qu'une personnalisation obligatoire
      manque. Un bouton désactivé n'émet aucun clic.
   2. GARDE : écouteur de clic sur WINDOW en capture (avant document/Vanga).
      Sur un produit avec chaîne, c'est NOUS qui ajoutons pendentif + chaîne
      en une requête /cart/add.js, puis on ouvre le tiroir Vanga.
   3. FICHIER : soumission native form.submit() (seul chemin multipart) ; la
      chaîne est alors posée « en attente » et ajoutée par emir-chaine-cart.js.
   Le bouton de paiement dynamique est masqué (CSS) sur ces formulaires.
   Interdit : MutationObserver sur le bouton (boucle avec la barre collante).
   ========================================================================== */
(function () {
  'use strict';

  var MAX_BYTES = 20 * 1024 * 1024;
  var OK_EXT = ['png', 'jpg', 'jpeg', 'webp', 'gif', 'svg', 'pdf', 'heic', 'heif'];
  var registry = []; /* une entrée par <form> */

  function humanSize(bytes) {
    if (bytes < 1024) return bytes + ' o';
    if (bytes < 1048576) return Math.round(bytes / 1024) + ' Ko';
    return (bytes / 1048576).toFixed(1).replace('.', ',') + ' Mo';
  }
  function extOf(name) {
    var i = String(name).lastIndexOf('.');
    return i === -1 ? '' : String(name).slice(i + 1).toLowerCase();
  }

  /* ---------- Argent ---------- */
  function formatMoney(cents, format) {
    format = String(format || '{{amount}}€').replace(/<[^>]*>/g, '');
    var m = /\{\{\s*(\w+)\s*\}\}/.exec(format);
    var key = m ? m[1] : 'amount';
    var value = Math.round(cents) / 100;
    var decimals = (key.indexOf('no_decimals') !== -1) ? 0 : 2;
    var fixed = value.toFixed(decimals);
    var parts = fixed.split('.');
    var thousands = ',', dec = '.';
    if (key.indexOf('comma_separator') !== -1) { thousands = '.'; dec = ','; }
    else if (key.indexOf('space_separator') !== -1) { thousands = ' '; dec = ','; }
    else if (key.indexOf('apostrophe_separator') !== -1) { thousands = "'"; dec = '.'; }
    var intPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var out = decimals ? intPart + dec + parts[1] : intPart;
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  /* Refonte 2026-10-12 : montant au format français (« 2 099 € », centimes seulement s'ils ne sont pas nuls),
     même règle que snippets/eix-p-montant et assets/eix-product.js. Utilisé quand la fiche fournit le symbole. */
  function montantFr(cents, symbole) {
    var c = Math.abs(Math.round(Number(cents) || 0)), e = Math.floor(c / 100), ct = c % 100;
    return String(e).replace(/\B(?=(\d{3})+(?!\d))/g, '\u202f') + (ct ? ',' + (ct < 10 ? '0' : '') + ct : '') + '\u00a0' + (symbole || '\u20ac');
  }
  /* Bouton de la nouvelle fiche : ses états (chargement, coche, erreur) sont dessinés par eix-product.js,
     on ne réécrit donc pas son libellé. */
  function boutonEix(button) { return !!(button && button.hasAttribute && button.hasAttribute('data-eix-btn')); }
  /* Notre garde (window, capture) arrête la propagation du clic : eix-product.js ne le voit pas.
     On lui indique donc nous-mêmes l'état à dessiner : 'charge', 'ok', 'erreur' ou null. */
  function etatEix(button, etat, message) {
    try { if (window.__eixProduct && window.__eixProduct.etat) window.__eixProduct.etat(button, etat, message); } catch (x) {}
  }

  /* ---------- Produit courant (JSON posé par le thème) ---------- */
  function productOf(form) {
    var host = form.closest ? form.closest('[data-product-form]') : null;
    if (!host) return null;
    if (host.__emirProduct !== undefined) return host.__emirProduct;
    var p = null;
    try { p = JSON.parse(host.getAttribute('data-product') || 'null'); } catch (e) { p = null; }
    host.__emirProduct = p;
    return p;
  }
  function moneyFormatOf(form) {
    var host = form.closest ? form.closest('[data-product-form]') : null;
    return (host && host.getAttribute('data-money-format')) || '{{amount}}€';
  }
  function currentVariant(form) {
    var idEl = form.querySelector('select[name="id"], input[name="id"]');
    var id = idEl ? parseInt(idEl.value, 10) : NaN;
    var p = productOf(form);
    if (!p || !p.variants) return { id: id, variant: null };
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].id === id) return { id: id, variant: p.variants[i] };
    }
    return { id: id, variant: null };
  }

  /* Nombre de lettres imposé par la variante (« 3 lettres », « Initiale simple ») */
  function lettersFromVariant(form) {
    var cv = currentVariant(form);
    var v = cv.variant;
    if (!v || !v.options) return null;
    for (var i = 0; i < v.options.length; i++) {
      var val = String(v.options[i] || '');
      var m = /(\d+)\s*lettre/i.exec(val);
      if (m) return parseInt(m[1], 10);
      if (/initiale/i.test(val)) return 1;
    }
    return null;
  }

  function entryFor(form) {
    for (var i = 0; i < registry.length; i++) if (registry[i].form === form) return registry[i];
    var e = {
      form: form,
      validators: [],
      errBoxes: [],
      roots: [],
      hasFile: function () { return false; },
      getChain: null,
      onChange: [],
      showErr: function (msg) {
        for (var k = 0; k < e.errBoxes.length; k++) {
          e.errBoxes[k].textContent = msg;
          e.errBoxes[k].classList.add('is-visible');
        }
        if (e.roots[0]) e.roots[0].classList.add('is-invalid');
      },
      clearErr: function () {
        for (var k = 0; k < e.errBoxes.length; k++) e.errBoxes[k].classList.remove('is-visible');
        for (var r = 0; r < e.roots.length; r++) e.roots[r].classList.remove('is-invalid');
      },
      validate: function () {
        for (var k = 0; k < e.validators.length; k++) {
          var msg = e.validators[k]();
          if (msg) return msg;
        }
        return null;
      },
      focusFirstEmpty: function () {
        var root = e.roots[0];
        if (!root) return;
        try { root.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (x) { root.scrollIntoView(); }
        var t = root.querySelector('[data-bv-perso-text]');
        if (t && !t.value.trim()) { try { t.focus({ preventScroll: true }); } catch (x) { t.focus(); } }
      }
    };
    /* ---------- VERROU ---------- (jamais de MutationObserver ici) */
    var gating = false, weDisabled = false;
    /* Indication visible sous le bouton verrouillé (2026-10-01) : un bouton
       désactivé n'émet aucun clic, le client doit savoir pourquoi. */
    function hintFor(b) {
      var h = b.__emirHint;
      if (!h || !h.parentNode) {
        h = document.createElement('p');
        h.className = 'bv-perso-lockhint';
        h.setAttribute('aria-live', 'polite');
        h.hidden = true;
        if (b.insertAdjacentElement) b.insertAdjacentElement('afterend', h);
        else if (b.parentNode) b.parentNode.insertBefore(h, b.nextSibling);
        b.__emirHint = h;
      }
      return h;
    }
    e.applyGate = function () {
      if (gating) return;
      gating = true;
      try {
        var msg = e.validate();
        var invalid = !!msg;
        var buttons = form.querySelectorAll('button[name="add"], input[name="add"]');
        Array.prototype.forEach.call(buttons, function (b) {
          var hint = hintFor(b);
          if (invalid) {
            if (!b.disabled) { b.disabled = true; weDisabled = true; }
            if (b.getAttribute('aria-disabled') !== 'true') b.setAttribute('aria-disabled', 'true');
            b.classList.add('bv-perso-locked');
            if (hint.textContent !== msg) hint.textContent = msg;
            hint.hidden = false;
          } else {
            hint.hidden = true;
            if (weDisabled) {
              b.disabled = false;
              b.removeAttribute('aria-disabled');
              b.classList.remove('bv-perso-locked');
            }
          }
        });
        if (!invalid) weDisabled = false;
        for (var r = 0; r < e.roots.length; r++) e.roots[r].classList.toggle('is-locked', invalid);
      } finally { gating = false; }
    };
    form.classList.add('bv-perso-form');
    form.setAttribute('enctype', 'multipart/form-data');
    /* Le thème réactive le bouton et change la variante via jQuery : on
       réévalue sur les événements natifs du formulaire + une passe différée. */
    form.addEventListener('change', function () {
      setTimeout(function () {
        for (var k = 0; k < e.onChange.length; k++) e.onChange[k]();
        e.applyGate();
      }, 0);
    });
    form.addEventListener('input', function () { e.clearErr(); });
    /* Toucher le bouton verrouillé (pointer-events:none en CSS) : le clic
       arrive sur la zone des boutons ; on explique et on amène au champ. */
    form.addEventListener('click', function (ev) {
      var t = ev.target;
      if (!t || !t.closest || !t.classList || !t.classList.contains('purchase-details__buttons')) return;
      var locked = t.querySelector('.bv-perso-locked');
      if (!locked) return;
      var r = locked.getBoundingClientRect();
      if (ev.clientX < r.left || ev.clientX > r.right || ev.clientY < r.top || ev.clientY > r.bottom) return;
      var msg = e.validate();
      if (msg) { e.showErr(msg); e.focusFirstEmpty(); }
    });
    setTimeout(e.applyGate, 1500);
    registry.push(e);
    return e;
  }

  /* ==================== PERSONNALISATION (texte / choix / fichier) ==================== */
  function initPerso(root) {
    if (root.getAttribute('data-bv-perso-ready') === '1') return;
    root.setAttribute('data-bv-perso-ready', '1');
    var form = root.closest ? root.closest('form') : null;
    if (!form) return;
    var e = entryFor(form);
    e.roots.push(root);

    var textInput = root.querySelector('[data-bv-perso-text]');
    var choice = root.querySelector('[data-bv-perso-choice]');
    var fileInput = root.querySelector('[data-bv-perso-file]');
    var counter = root.querySelector('[data-bv-perso-count]');
    var counterWrap = root.querySelector('[data-bv-perso-countwrap]');
    var maxLabel = root.querySelector('[data-bv-perso-max]');
    var errBox = root.querySelector('[data-bv-perso-err]');
    var drop = root.querySelector('[data-bv-perso-drop]');
    var dropName = root.querySelector('[data-bv-perso-name]');
    var dropDefault = dropName ? dropName.textContent : '';
    var phDefault = textInput ? (textInput.getAttribute('placeholder') || '') : '';
    var PH_EX = { 1: 'A', 2: 'JR', 3: 'Sam', 4: 'Emir', 5: 'Lucas', 6: 'Hustle', 7: 'Charles' };
    var required = root.getAttribute('data-required') === 'true';
    var maxDefault = parseInt(root.getAttribute('data-max-default'), 10) || 30;
    if (errBox) e.errBoxes.push(errBox);

    function hasFile() { return !!(fileInput && fileInput.files && fileInput.files.length); }
    e.hasFile = hasFile;

    function currentMax() {
      var n = lettersFromVariant(form);
      return n || maxDefault;
    }
    function applyMax() {
      if (!textInput) return;
      var max = currentMax();
      textInput.setAttribute('maxlength', String(max));
      if (textInput.value.length > max) textInput.value = textInput.value.slice(0, max);
      if (maxLabel) maxLabel.textContent = String(max);
      /* L'exemple suit le nombre de lettres de la variante (« Exemple : Sam » pour 2 lettres bloquait à « Sa ») */
      if (/^\s*exemple\s*:/i.test(phDefault)) {
        var n = lettersFromVariant(form);
        var ex = n ? PH_EX[n] : null;
        textInput.setAttribute('placeholder', ex ? 'Exemple : ' + ex : phDefault);
      }
      refreshCount();
    }
    function refreshCount() {
      if (!textInput || !counter) return;
      var max = parseInt(textInput.getAttribute('maxlength'), 10) || 0;
      counter.textContent = String(textInput.value.length);
      if (counterWrap) counterWrap.classList.toggle('is-full', !!max && textInput.value.length >= max);
    }

    e.validators.push(function () {
      if (!required) return null;
      if (choice && !choice.value) return 'Merci de faire votre choix (' + (choice.previousElementSibling ? choice.previousElementSibling.textContent.replace('*', '').trim() : 'option') + ') avant d’ajouter au panier.';
      if (textInput && !textInput.value.trim()) return 'Merci de renseigner votre personnalisation avant d’ajouter au panier.';
      if (fileInput && !hasFile()) return 'Merci de joindre votre visuel avant d’ajouter au panier.';
      return null;
    });
    e.validators.push(function () {
      if (!textInput) return null;
      var n = lettersFromVariant(form);
      if (n && textInput.value.trim().length > n) return 'Votre variante permet ' + n + ' caractère' + (n > 1 ? 's' : '') + ' maximum.';
      return null;
    });
    e.onChange.push(applyMax);

    function refreshFile() {
      if (!fileInput || !drop) return;
      var f = fileInput.files && fileInput.files[0];
      if (!f) {
        drop.classList.remove('is-filled');
        if (dropName) dropName.textContent = dropDefault;
        e.applyGate(); return;
      }
      if (f.size > MAX_BYTES) {
        fileInput.value = ''; drop.classList.remove('is-filled');
        if (dropName) dropName.textContent = dropDefault;
        e.showErr('Fichier trop lourd (' + humanSize(f.size) + '). Maximum accepté : 20 Mo.');
        e.applyGate(); return;
      }
      if (OK_EXT.indexOf(extOf(f.name)) === -1) {
        fileInput.value = ''; drop.classList.remove('is-filled');
        if (dropName) dropName.textContent = dropDefault;
        e.showErr('Format non accepté. Envoyez une image (JPG, PNG, WEBP, SVG) ou un PDF.');
        e.applyGate(); return;
      }
      e.clearErr();
      drop.classList.add('is-filled');
      if (dropName) dropName.textContent = f.name + ' — ' + humanSize(f.size);
      e.applyGate();
    }

    if (textInput) {
      textInput.addEventListener('input', function () { refreshCount(); e.clearErr(); e.applyGate(); });
      applyMax();
    }
    if (choice) choice.addEventListener('change', function () { e.clearErr(); });
    if (fileInput) { fileInput.addEventListener('change', refreshFile); refreshFile(); }
    if (drop && fileInput) {
      ['dragenter', 'dragover'].forEach(function (evt) {
        drop.addEventListener(evt, function (ev) { ev.preventDefault(); ev.stopPropagation(); drop.classList.add('is-over'); });
      });
      ['dragleave', 'drop'].forEach(function (evt) {
        drop.addEventListener(evt, function (ev) { ev.preventDefault(); ev.stopPropagation(); drop.classList.remove('is-over'); });
      });
      drop.addEventListener('drop', function (ev) {
        var dt = ev.dataTransfer;
        if (dt && dt.files && dt.files.length) {
          try { fileInput.files = dt.files; } catch (err) { return; }
          refreshFile();
        }
      });
    }
    e.applyGate();
  }

  /* ==================== CHAÎNE COMPAGNON ==================== */
  function initChaine(root) {
    if (root.getAttribute('data-emir-chaine-ready') === '1') return;
    root.setAttribute('data-emir-chaine-ready', '1');
    var form = root.closest ? root.closest('form') : null;
    if (!form) return;
    var e = entryFor(form);
    e.roots.push(root);

    var models = root.querySelectorAll('[data-emir-chaine-model]');
    var groups = root.querySelectorAll('[data-emir-lengths]');
    var prop = root.querySelector('[data-emir-chaine-prop]');
    var totalWrap = root.querySelector('[data-emir-chaine-total]');
    var totalVal = root.querySelector('[data-emir-chaine-total-value]');
    var errBox = root.querySelector('[data-emir-chaine-err]');
    if (errBox) e.errBoxes.push(errBox);

    function currentModel() {
      for (var i = 0; i < models.length; i++) if (models[i].checked) return models[i].value;
      return models[0] ? models[0].value : '';
    }
    function groupFor(model) {
      for (var i = 0; i < groups.length; i++) if (groups[i].getAttribute('data-emir-lengths') === model) return groups[i];
      return null;
    }
    function chosen() {
      var g = groupFor(currentModel());
      return g ? g.querySelector('input[data-emir-chaine-variant]:checked') : null;
    }
    function refresh() {
      var model = currentModel();
      Array.prototype.forEach.call(models, function (m) {
        var lab = m.closest('label');
        if (lab) lab.classList.toggle('is-selected', m.checked);
      });
      Array.prototype.forEach.call(groups, function (g) {
        g.hidden = g.getAttribute('data-emir-lengths') !== model;
        Array.prototype.forEach.call(g.querySelectorAll('input[data-emir-chaine-variant]'), function (inp) {
          var lab = inp.closest('label');
          if (lab) lab.classList.toggle('is-selected', inp.checked);
        });
      });
      var c = chosen();
      if (prop) prop.value = c ? c.getAttribute('data-label') : '';
      /* total pendentif + chaîne */
      var cv = currentVariant(form);
      if (totalWrap && totalVal && c && cv.variant && typeof cv.variant.price === 'number') {
        var qtyEl = form.querySelector('input[name="quantity"]');
        var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
        var total = (cv.variant.price + (parseInt(c.getAttribute('data-price'), 10) || 0)) * qty;
        var symbole = root.getAttribute('data-eix-symbole');
        totalVal.textContent = symbole ? montantFr(total, symbole) : formatMoney(total, moneyFormatOf(form));
        totalWrap.hidden = false;
      } else if (totalWrap) {
        totalWrap.hidden = true;
      }
    }
    root.addEventListener('change', function () { setTimeout(refresh, 0); });
    e.onChange.push(refresh);
    e.validators.push(function () { return chosen() ? null : 'Merci de choisir la longueur de votre chaîne.'; });
    e.getChain = function () {
      var c = chosen();
      if (!c) return null;
      return {
        id: parseInt(c.value, 10),
        price: parseInt(c.getAttribute('data-price'), 10) || 0,
        label: c.getAttribute('data-label') || ''
      };
    };
    refresh();
    e.applyGate();
  }

  /* ==================== AJOUT AU PANIER (pendentif + chaîne) ==================== */
  function collectProperties(form) {
    var props = {};
    Array.prototype.forEach.call(form.querySelectorAll('[name^="properties["]'), function (el) {
      if (el.type === 'file') return;
      if (el.closest && el.closest('#infiniteoptions-container')) return; /* reliquat Infinite Options */
      if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
      var m = /^properties\[(.+)\]$/.exec(el.name);
      if (!m) return;
      var v = String(el.value || '').trim();
      if (v !== '') props[m[1]] = v;
    });
    return props;
  }
  function newKey() { return 'c' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7); }

  function setBusy(button, busy) {
    if (!button) return;
    if (boutonEix(button)) {
      button.disabled = !!busy;
      button.classList.toggle('emir-busy', !!busy);
      etatEix(button, busy ? 'charge' : null);
      return;
    }
    var txt = button.querySelector('.text') || button;
    if (busy) {
      if (button.__emirLabel === undefined) button.__emirLabel = txt.textContent;
      txt.textContent = 'Ajout en cours…';
      button.disabled = true;
      button.classList.add('emir-busy');
    } else {
      if (button.__emirLabel !== undefined) txt.textContent = button.__emirLabel;
      button.disabled = false;
      button.classList.remove('emir-busy');
    }
  }
  function flash(button, label) {
    if (!button) return;
    if (boutonEix(button)) { etatEix(button, 'ok'); return; }
    var txt = button.querySelector('.text') || button;
    var old = txt.textContent;
    txt.textContent = label;
    button.classList.add('emir-added');
    setTimeout(function () { txt.textContent = old; button.classList.remove('emir-added'); }, 2200);
  }

  function afterAdd(button) {
    setBusy(button, false);
    flash(button, 'Ajouté au panier ✓');
    try { document.dispatchEvent(new CustomEvent('emir:cart:added')); } catch (x) {}
    if (window.Vanga && typeof window.Vanga.refresh === 'function') {
      try { window.Vanga.refresh(); } catch (x) {}
      if (typeof window.Vanga.open === 'function') { try { window.Vanga.open(); } catch (x) {} }
      return;
    }
    window.location.href = '/cart';
  }

  function addWithChain(e, button) {
    var form = e.form;
    var cv = currentVariant(form);
    if (!cv.id) { e.showErr('Sélectionnez d’abord une variante.'); return; }
    var qtyEl = form.querySelector('input[name="quantity"]');
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    var chain = e.getChain();
    var key = newKey();
    var p = productOf(form);
    var props = collectProperties(form);
    props._emir_bundle = key;
    var items = [{ id: cv.id, quantity: qty, properties: props }];
    if (chain) {
      items.push({ id: chain.id, quantity: qty, properties: { _emir_chaine_pour: key, 'Pour': (p && p.title) || 'pendentif' } });
    }
    setBusy(button, true);
    e.clearErr();
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, body: j }; }, function () { return { ok: r.ok, body: null }; });
    }).then(function (res) {
      if (!res.ok) {
        var msg = (res.body && (res.body.description || res.body.message)) || 'erreur inconnue';
        throw new Error(msg);
      }
      afterAdd(button);
    }).catch(function (err) {
      setBusy(button, false);
      e.showErr('Impossible d’ajouter au panier : ' + err.message);
      if (boutonEix(button)) etatEix(button, 'erreur', 'Impossible d’ajouter au panier : ' + err.message);
    });
  }

  /* ---------- GARDE : window, phase de capture (avant Vanga / thème) ---------- */
  function findEntry(form) {
    for (var i = 0; i < registry.length; i++) if (registry[i].form === form) return registry[i];
    return null;
  }
  function windowGuard(ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var trigger = t.closest('[name="add"], .add_to_cart, .ajax-submit, .shopify-payment-button');
    if (!trigger) return;
    var form = trigger.closest ? trigger.closest('form') : null;
    var e = form ? findEntry(form) : null;
    if (!e) return;

    var msg = e.validate();
    if (msg) {
      ev.preventDefault(); ev.stopImmediatePropagation();
      e.showErr(msg); e.focusFirstEmpty();
      return false;
    }
    if (e.hasFile()) {
      /* Fichier joint : POST natif multipart, la chaîne suit après rechargement. */
      ev.preventDefault(); ev.stopImmediatePropagation();
      var chain = e.getChain ? e.getChain() : null;
      if (chain) {
        var key = newKey();
        var qtyEl = e.form.querySelector('input[name="quantity"]');
        var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
        var hidden = document.createElement('input');
        hidden.type = 'hidden'; hidden.name = 'properties[_emir_bundle]'; hidden.value = key;
        e.form.appendChild(hidden);
        var p = productOf(e.form);
        try { window.sessionStorage.setItem('emir_pending_chain', JSON.stringify({ id: chain.id, qty: qty, key: key, title: (p && p.title) || '' })); } catch (x) {}
      }
      e.form.setAttribute('enctype', 'multipart/form-data');
      e.form.submit();
      return false;
    }
    if (e.getChain && e.getChain()) {
      ev.preventDefault(); ev.stopImmediatePropagation();
      addWithChain(e, trigger.closest('button, input') || trigger);
      return false;
    }
    /* Personnalisation texte seule : le flux normal du thème / des apps
       transporte déjà les propriétés du formulaire. */
  }
  window.addEventListener('click', windowGuard, true);
  window.addEventListener('submit', function (ev) {
    var e = findEntry(ev.target);
    if (!e) return;
    var msg = e.validate();
    if (msg) {
      ev.preventDefault(); ev.stopImmediatePropagation();
      e.showErr(msg); e.focusFirstEmpty();
      return false;
    }
  }, true);

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bv-perso]'), initPerso);
    Array.prototype.forEach.call(document.querySelectorAll('[data-emir-chaine]'), initChaine);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('page:load', boot);
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('quickshop:loaded', boot);
  if (window.InstantClick && typeof window.InstantClick.on === 'function') window.InstantClick.on('change', boot);
  /* Quick shop Turbo : le formulaire arrive après coup, on repasse un peu plus tard. */
  setTimeout(boot, 1200);
  setTimeout(boot, 3000);
})();
